import { SLEEPING_CITY_BRICKS } from '../physics/yardPhysics';

export const SLEEPING_CITY_MOBILE_BRICKS = 2000;

export function sleepingCityBodyLimitForUserAgent(userAgent: string): number {
  return /Android|iPhone|iPad|iPod|Mobile/i.test(userAgent) ? SLEEPING_CITY_MOBILE_BRICKS : SLEEPING_CITY_BRICKS;
}
